import React, { useState } from 'react';
import roni from '../pic/roni.png'

const AboutMe = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        console.log(index)
        setToggleState(index);
    };
    return (
        <div id="aboutMe" className='py-10 mx-auto text-center lg:px-20 px-10 grid grid-cols-1 lg:grid-cols-2'>
            <div className=' text-start px-5 lg:px-0'>
                <h1>About Me</h1>
                <p>Hello! My name is Rahul Dhar Roni , from Sylhet, Bangladesh.

                </p>
                <p className='py-5'>I am a Programming lover and self- taught web developer practicing ES6, React, Node, MongoDB, Express, Rest API, Material UI, SASS, JSON, and so on.
                </p>
                <p className='py-5'>I am very interested in learning new technologies and working with them. I always try to incorporate my acquired knowledge into real life projects and constantly and further develop my acquired knowledge.
                </p>
                <p>
                    Here are a few technologies I’ve been working with recently:
                </p>

                <div class="tabs my-5">
                    <a onClick={() => toggleTab(1)} className={toggleState === 1 ? "tab tab-lifted tab-active" : "tab tab-lifted text-slate-500"}>Frontend</a>
                    <a onClick={() => toggleTab(2)} className={toggleState === 2 ? "tab tab-lifted tab-active" : "tab tab-lifted text-slate-500"}>Backend</a>
                    <a onClick={() => toggleTab(3)} className={toggleState === 3 ? "tab tab-lifted tab-active" : "tab tab-lifted text-slate-500"}>Database</a>
                    <a onClick={() => toggleTab(4)} className={toggleState === 4 ? "tab tab-lifted tab-active" : "tab tab-lifted text-slate-500"}>CMS, Tools and Deploy</a>
                </div>
                <div>
                    <div className={toggleState === 1 ? "flex flex-wrap w-96" : "hidden"}>
                        <img src="https://img.shields.io/badge/HTML5-E34F26?style=for-the-badge&logo=html5&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/CSS3-1572B6?style=for-the-badge&logo=css3&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB" alt=""
                            className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Bootstrap-563D7C?style=for-the-badge&logo=bootstrap&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/React_Router-CA4245?style=for-the-badge&logo=react-router&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/json%20web%20tokens-323330?style=for-the-badge&logo=json-web-tokens&logoColor=pink" alt="" className="rounded m-1 w-24" />



                    </div>
                    <div className={toggleState === 2 ? "flex" : "hidden"}>
                        <img src="https://img.shields.io/badge/Express.js-404D59?style=for-the-badge" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node.js&logoColor=white" alt="" className="rounded m-1 w-24" />
                    </div>
                    <div className={toggleState === 3 ? "flex" : "hidden"}>

                        <img src="https://img.shields.io/badge/MongoDB-4EA94B?style=for-the-badge&logo=mongodb&logoColor=white" alt=""
                            className="rounded m-1 w-24" />

                    </div>
                    <div className={toggleState === 4 ? "flex flex-wrap w-96" : "hidden"}>

                        <img src="https://img.shields.io/badge/Wordpress-21759B?style=for-the-badge&logo=wordpress&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Wix-000?style=for-the-badge&logo=wix&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Adobe%20Photoshop-31A8FF?style=for-the-badge&logo=Adobe%20Photoshop&logoColor=black" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Adobe%20Illustrator-FF9A00?style=for-the-badge&logo=adobe%20illustrator&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Netlify-00C7B7?style=for-the-badge&logo=netlify&logoColor=white" alt="" className="rounded m-1 w-24" />
                        <img src="https://img.shields.io/badge/Heroku-430098?style=for-the-badge&logo=heroku&logoColor=white" alt="" className="rounded m-1 w-24" />

                    </div>
                </div>
            </div>
            <div className='rounded  mx-auto my-5'>
                <img src={roni} alt="" className="w-96 mx-auto grayscale hover:grayscale-0 hover:-translate-x-6 hover:scale-100 shadow-lg shadow-cyan-500/50 hover:shadow-none rounded" />
            </div>
        </div>
    );
};

export default AboutMe;